export default __webpack_public_path__ + "assets/trust.2a35dd44.svg";